import React from "react";
import Header from "../../Home/Header";
import Footer from "../../Home/Footer";
import NFTWalletDev from "./NFTWalletDev";
import NFTWalletDevS from "./NFTWalletDevS";
import SecureStorage from "./SecureStorage";
import WhyChoose from "./WhyChoose";
import DevelopmentApproach from "./DevelopmentApproach";

function NFTWallet() {
  return (
    <>
      <Header />
      <NFTWalletDev />
      <NFTWalletDevS />
      <SecureStorage />
      <DevelopmentApproach />
      <WhyChoose />
      <Footer />
    </>
  );
}

export default NFTWallet;
